import { render, staticRenderFns } from "./ERC20.vue?vue&type=template&id=1bfc1384&"
import script from "./ERC20.vue?vue&type=script&lang=js&"
export * from "./ERC20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports